import { useState, useContext, useEffect } from 'react';

import '../../../../assets/scss/deliverables.scss';
import Modal from '../../../components/modals';
import Context from '../../../../context/context';
import Select from 'react-select';
import { ReactComponent as Cancel } from '../../../../assets/svg/cancel-icon.svg';
import { useNavigate, useParams } from 'react-router-dom';
const DeliverablesCreateModal = () => {
	const urlParams = useParams();
	const navigate = useNavigate();

	let {
		deliverableInfo: {
			modalShow,
			updateModalState,
			associatedTenants,
			workspaceProjectList,
			getAllWorkspaceProjects,
		},
	} = useContext(Context);

	const [data, setdata] = useState({
		projectsListOptions: [],
		associatedTenantsOptions: [],
		selectedworkspace: '',
		selectedProject: '',
	});

	useEffect(() => {
		let associatedTenant = associatedTenants?.vendorInfo?.associatedTenants;
		let associatedTenantsOptions = associatedTenant?.map((ele) => {
			return {
				label: ele.workspaceId,
				value: ele._id,
			};
		});
		setdata((prev) => {
			return {
				...prev,
				associatedTenantsOptions,
			};
		});
	}, [associatedTenants]);

	useEffect(() => {
		if (data.selectedworkspace) {
			let wjson = {
				workspaceIds: data.selectedworkspace?.label,
				filters: {
					limit: 1000,
					page: 1,
				},
			};

			getAllWorkspaceProjects(wjson, urlParams.vendorID);
		}
	}, [data.selectedworkspace]);

	useEffect(() => {
		if (workspaceProjectList) {
			let projectsListOptions = workspaceProjectList?.vendorsProjects?.data.map((ele) => {
				return { label: ele.title, value: ele.id };
			});
			setdata((prev) => {
				return { ...prev, projectsListOptions };
			});
		}
	}, [workspaceProjectList]);

	return (
		<Modal
			handleClose={() => updateModalState('modalShow', false)}
			show={modalShow}
			modalType={'center'}
		>
			<div
				className="mc-record-center-modal2"
				style={{
					minHeight: data.selectedworkspace ? '356px' : '256px',
					width: '640px',
				}}
			>
				<div className="mc-record-header">
					<span className="header-title">CREATE NEW DELIVERABLE</span>
					<span
						className="header-more-icn"
						onClick={() => updateModalState('modalShow', false)}
					>
						<Cancel />
					</span>
				</div>

				<>
					<div
						style={{
							height: '100%',
							width: '100%',
							marginTop: '2vh',
						}}
					>
						<div
							style={{
								height: '100%',
								width: '100%',
								flexDirection: 'column',
								justifyContent: 'center',
								alignItems: 'center',
							}}
						>
							<div
								style={{
									width: '640px',
									padding: '30px',
									position: 'fixed',
									zIndex: '9999',
								}}
							>
								<label
									style={{
										color: '#B0B0B0',
										fontSize: '13px',
										fontStyle: 'normal',
										fontWeight: '400',
										lineHeight: '16px',
										letterSpacing: '-0.3px',
									}}
								>
									Workspace*
								</label>
								<br />

								<Select
									className="cost-select-container"
									classNamePrefix="cost-select"
									options={data.associatedTenantsOptions}
									onChange={(e) => {
										setdata((prev) => {
											return {
												...prev,
												selectedworkspace: e,
												selectedProject: null,
											};
										});
									}}
								/>
							</div>
							{data.selectedworkspace && data.projectsListOptions?.length ? (
								<div
									style={{
										width: '640px',
										padding: '30px',
										position: 'fixed',
										marginTop: '10vh',
										zIndex: '1000',
									}}
								>
									<label
										style={{
											color: '#B0B0B0',
											fontSize: '13px',
											fontStyle: 'normal',
											fontWeight: '400',
											lineHeight: '16px',
											letterSpacing: '-0.3px',
										}}
									>
										Project*
									</label>
									<br />

									<Select
										value={data.selectedProject}
										className="cost-select-container"
										classNamePrefix="cost-select"
										options={data.projectsListOptions}
										onChange={(e) => {
											setdata((prev) => {
												return {
													...prev,
													selectedProject: e,
												};
											});
										}}
									/>
								</div>
							) : (
								''
							)}
						</div>
						{data.selectedworkspace && data.selectedProject ? (
							<div
								style={{
									position: 'relative',
									display: 'flex',
									padding: '24px',
									justifyContent: 'flex-end',
									marginTop: '23vh',
								}}
							>
								<div
									className="create-shoot-btn"
									onClick={async () => {
										updateModalState('modalShow', false);
										navigate(
											`/${urlParams.vendorID}/deliverables/${data.selectedworkspace.label}/${data.selectedProject.value}?workspaceId=${data.selectedworkspace.value}&projectLabel=${data.selectedProject.label}`,
										);
									}}
								>
									Proceed
								</div>
							</div>
						) : (
							''
						)}
					</div>
				</>
			</div>
		</Modal>
	);
};

export default DeliverablesCreateModal;
